"use client"

import type React from "react"
import { useEffect, useRef } from "react"
import { mouseStore } from "../mouseStore"

interface CursorSpotlightProps {
  /** Spotlight fill color (use rgba for transparency) */
  color?: string
  /** Diameter of the spotlight in px */
  size?: number
  /** CSS z-index */
  zIndex?: number
  /** CSS mix-blend-mode */
  blend?: React.CSSProperties["mixBlendMode"]
}

export const CursorSpotlight: React.FC<CursorSpotlightProps> = ({
  color = "rgba(255,255,255,0.06)",
  size = 400,
  zIndex = 0,
  blend = "normal",
}) => {
  const ref = useRef<HTMLDivElement>(null)

  useEffect(() => {
    const el = ref.current
    if (!el) return
    const r = size / 2

    return mouseStore.subscribe((x, y) => {
      el.style.background = `radial-gradient(circle at ${x}px ${y}px, ${color} 0px, transparent ${r}px)`
    })
  }, [color, size])

  return (
    <div
      ref={ref}
      aria-hidden="true"
      style={{
        position: "fixed",
        inset: 0,
        pointerEvents: "none",
        zIndex,
        mixBlendMode: blend,
        willChange: "background",
      }}
    />
  )
}
